import { VisitorLimitsType } from '@fund-base/types/visitors/visitor-limits.types';
import { createAction, props } from '@ngrx/store';

export const setVisitorLoading = createAction('[Visitor] set visitor loading state', props<{ loading: boolean }>());
export const setVisitorLimits = createAction('[Visitor] Set limits', props<{ limits: VisitorLimitsType }>());
export const incrementVisitorSearchCount = createAction('[Visitor] Increment search count');
export const incrementVisitorAILettersCount = createAction('[Visitor] Increment AI letters count');
export const setVisitorStartDate = createAction('[Visitor] Set start date', props<{ startDate: Date }>());
